/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './error.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/components/error/error.component';
const styles_ErrorComponent:any[] = [i0.styles];
export const RenderType_ErrorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ErrorComponent,data:{}});
export function View_ErrorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'div',[['class',
      'not-found']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n	'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),[' We\'re sorry, but the page you\'re looking for can\'t be found'])),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],
      (null as any),(null as any));
}
export function View_ErrorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_ErrorComponent_0,
      RenderType_ErrorComponent)),i1.ɵdid(49152,(null as any),0,i2.ErrorComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const ErrorComponentNgFactory:i1.ComponentFactory<i2.ErrorComponent> = i1.ɵccf('ng-component',
    i2.ErrorComponent,View_ErrorComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2Vycm9yL2Vycm9yLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9lcnJvci9lcnJvci5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL25vZGUvYXBwL3NyYy9hcHAvY29tcG9uZW50cy9lcnJvci9lcnJvci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2Vycm9yL2Vycm9yLmNvbXBvbmVudC50cy5FcnJvckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJub3QtZm91bmRcIj5cblx0PGgyPiBXZSdyZSBzb3JyeSwgYnV0IHRoZSBwYWdlIHlvdSdyZSBsb29raW5nIGZvciBjYW4ndCBiZSBmb3VuZDwvaDI+XG48L2Rpdj5cbiIsIjxuZy1jb21wb25lbnQ+PC9uZy1jb21wb25lbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBdUIsd0NBQ3RCO1VBQUE7VUFBQSxnQkFBSTtNQUFpRSx1Q0FDaEU7Ozs7b0JDRk47TUFBQTsrQkFBQSxVQUFBO01BQUE7OzsifQ==



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/error/error.component.ngfactory.ts